module.exports = __webpack_public_path__ + "static/img/IMG_20170305_125439-PANO.da190971.jpg";